import { Injectable } from '@angular/core';

import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';


import { GlobalCfgService } from './globalcfg.service';

/**
*	Provider to do the parts related funtionality.
*/
@Injectable()
export class ExpiryReportService {


    constructor(
		private http: HttpClient,
		private globalCfgService : GlobalCfgService) {
	}

	public expiryReport(obj) {
		
		return this.http.post(environment.apiurl + "/Reports/expiry?access_token=" + this.globalCfgService.getAccessToken(), obj);
	}
	
}

	

